/**
 * NSL event ids, as configured in the console's Event settings.
 *
 * /v1/events requires the numeric id - it will not resolve an event by name -
 * so these must match the tenant's configuration exactly.
 */
export const NEURON_EVENTS = Object.freeze({
  viewed: 1743190830019,
  hovered: 1743190718951,
  impression: 1767130944086053,
  /**
   * A stated-intent signal: the reader searched, then opened a result. Weighted
   * higher than a passive view because the query tells us what they were after.
   */
  searchResultOpened: 1788687690714007,
});
